const starterSettings = {
  newsletter: false,
  petReward: false,
  accountType: "",
  lastPointsAddedDate:"2024-01-12",
};

export default starterSettings;
